import { View, StyleSheet } from 'react-native'
import { DS } from '../../../design-system'
import MaterialIcons from '@expo/vector-icons/MaterialIcons'
import { PokerCard } from '../../GameAssets/Cards/PokerCard'
import { Suit, Value } from 'pokersolver'

interface IPlayerInfoCard {
  title: string
  subtitle: string
  metric: string
  icon: keyof typeof MaterialIcons.glyphMap
  cards?: string[]
  showCards?: boolean
}

export const PlayerInfoCard = ({ title, subtitle, metric, icon, cards, showCards = false }: IPlayerInfoCard) => {
  return (
    <DS.Frame style={styles.body}>
      <MaterialIcons name={icon} size={30} color={DS.palette['Admin/Icon']} />
      <DS.Frame>
        <DS.Frame style={styles.cardTitle}>
          <DS.Text variant="Heading 3/Regular" color="Brand/Dark Grey">
            {title}:
          </DS.Text>
          <DS.Text variant="Heading 3/Medium">{metric}</DS.Text>
        </DS.Frame>
        <DS.Frame style={styles.subtitleContainer}>
          <DS.Text variant="Body Medium/Regular" color="Brand/Dark Grey">
            {subtitle}
          </DS.Text>
          {showCards && (
            <DS.Frame style={styles.cardsContainer}>
              {cards?.map((card, index) => (
                <PokerCard.Front key={index} size={20} value={card[0] as Value} suit={card[1] as Suit} />
              ))}
            </DS.Frame>
          )}
        </DS.Frame>
      </DS.Frame>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  body: { flexDirection: 'row', gap: 8 },
  cardTitle: {
    flexDirection: 'row',
    gap: 4
  },
  subtitleContainer: { flexDirection: 'row', gap: 4 },
  iconContainer: {
    width: 50,
    height: 50,
    borderRadius: 25,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: DS.palette['Admin/Badge']
  },
  cardsContainer: { flexDirection: 'row', gap: 1 }
})
